/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  StripeTransactionType,
  StripeTransactionTypeOptional,
  StripeTransactionTypeMetaI,
  StripeTransactionTypeTrackedI,
} from "./stripe-transaction-type";
import {
  StripeTransactionTypeTracked,
  StripeTransactionTypeMeta,
} from "./stripe-transaction-type";

/**
 *
 * @export
 * @interface StripeTransactionBase
 */
export interface StripeTransactionBaseOptional {
  /**
   *
   * @type {StripeTransactionType}
   * @memberof StripeTransactionBase
   */
  transactionType?: StripeTransactionType;
  /**
   *
   * @type {string}
   * @memberof StripeTransactionBase
   */
  stripePaymentIntent?: string;
  /**
   *
   * @type {string}
   * @memberof StripeTransactionBase
   */
  stripePaymentSecret?: string;
  /**
   *
   * @type {number}
   * @memberof StripeTransactionBase
   */
  transactionAmountCents?: number;
  /**
   *
   * @type {boolean}
   * @memberof StripeTransactionBase
   */
  offSession?: boolean;
}

export interface StripeTransactionBase extends StripeTransactionBaseOptional {
  /**
   *
   * @type {StripeTransactionType}
   * @memberof StripeTransactionBase
   */
  transactionType?: StripeTransactionType;
  /**
   *
   * @type {string}
   * @memberof StripeTransactionBase
   */
  stripePaymentIntent: string;
  /**
   *
   * @type {string}
   * @memberof StripeTransactionBase
   */
  stripePaymentSecret?: string;
  /**
   *
   * @type {number}
   * @memberof StripeTransactionBase
   */
  transactionAmountCents: number;
  /**
   *
   * @type {boolean}
   * @memberof StripeTransactionBase
   */
  offSession?: boolean;
}

export interface StripeTransactionBaseTrackedI {
  /**
   *
   * @type {StripeTransactionType}
   * @memberof StripeTransactionBase
   */
  transactionType?: StripeTransactionType;
  transactionTypeIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof StripeTransactionBase
   */
  stripePaymentIntent?: string;
  stripePaymentIntentIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof StripeTransactionBase
   */
  stripePaymentSecret?: string;
  stripePaymentSecretIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof StripeTransactionBase
   */
  transactionAmountCents?: number;
  transactionAmountCentsIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof StripeTransactionBase
   */
  offSession?: boolean;
  offSessionIsSet: boolean;
}

transformDatesMap.set(
  "StripeTransactionBase",
  function (model: StripeTransactionBase) {},
);

export type StripeTransactionBaseMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  transactionType: PropertyMeta<StripeTransactionTypeMetaI>;
  //isDate: false
  //isDatetime: false
  stripePaymentIntent: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  stripePaymentSecret: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  transactionAmountCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  offSession: PropertyMeta<MetaTypeBase<boolean>>;
}>;

export var StripeTransactionBaseMeta: StripeTransactionBaseMetaI =
  {} as StripeTransactionBaseMetaI;
StripeTransactionBaseMeta = typeMeta("StripeTransactionBase", {
  transactionType: propertyMeta(
    "transactionType",
    false,
    false,
    false,
    StripeTransactionTypeMeta,
  ),
  stripePaymentIntent: propertyMeta(
    "stripePaymentIntent",
    false,
    true,
    false,
    MetaTypesBase.string,
  ),
  stripePaymentSecret: propertyMeta(
    "stripePaymentSecret",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  transactionAmountCents: propertyMeta(
    "transactionAmountCents",
    false,
    true,
    false,
    MetaTypesBase.number,
  ),
  offSession: propertyMeta(
    "offSession",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
});

const metaI = StripeTransactionBaseMeta;

registerMeta(() => {});

export class StripeTransactionBaseTracked implements StripeTransactionBaseTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  transactionType__I?: StripeTransactionType = undefined;
  transactionTypeIsSet: boolean = false;
  set transactionType(v: undefined | StripeTransactionType) {
    if (v !== undefined) {
      this.transactionType__I = v;
      this.transactionTypeIsSet = true;
    } else {
      this.transactionType__I = v || undefined;
      this.transactionTypeIsSet = false;
    }
    this.changeTracker = true;
  }
  get transactionType() {
    return this.transactionType__I;
  }
  stripePaymentIntent__I?: string = undefined;
  stripePaymentIntentIsSet: boolean = false;
  set stripePaymentIntent(v: undefined | string) {
    if (v !== undefined) {
      this.stripePaymentIntent__I = v;
      this.stripePaymentIntentIsSet = true;
    } else {
      this.stripePaymentIntent__I = v || undefined;
      this.stripePaymentIntentIsSet = true;
    }
    this.changeTracker = true;
  }
  get stripePaymentIntent() {
    return this.stripePaymentIntent__I;
  }
  stripePaymentSecret__I?: string = undefined;
  stripePaymentSecretIsSet: boolean = false;
  set stripePaymentSecret(v: undefined | string) {
    if (v !== undefined) {
      this.stripePaymentSecret__I = v;
      this.stripePaymentSecretIsSet = true;
    } else {
      this.stripePaymentSecret__I = v || undefined;
      this.stripePaymentSecretIsSet = false;
    }
    this.changeTracker = true;
  }
  get stripePaymentSecret() {
    return this.stripePaymentSecret__I;
  }
  transactionAmountCents__I?: number = undefined;
  transactionAmountCentsIsSet: boolean = false;
  set transactionAmountCents(v: undefined | number) {
    if (v !== undefined) {
      this.transactionAmountCents__I = v;
      this.transactionAmountCentsIsSet = true;
    } else {
      this.transactionAmountCents__I = v || undefined;
      this.transactionAmountCentsIsSet = true;
    }
    this.changeTracker = true;
  }
  get transactionAmountCents() {
    return this.transactionAmountCents__I;
  }
  offSession__I?: boolean = undefined;
  offSessionIsSet: boolean = false;
  set offSession(v: undefined | boolean) {
    if (v !== undefined) {
      this.offSession__I = v;
      this.offSessionIsSet = true;
    } else {
      this.offSession__I = v || undefined;
      this.offSessionIsSet = false;
    }
    this.changeTracker = true;
  }
  get offSession() {
    return this.offSession__I;
  }
  constructor(config?: StripeTransactionBaseOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {}
  assignFrom(
    config: StripeTransactionBaseOptional,
    options?: AssignOptions,
  ): StripeTransactionBaseTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (
      config.transactionType &&
      this.transactionTypeApplyFilter(optionsRequired.filter)
    ) {
      this.transactionType = config.transactionType;
      if (optionsRequired.unassign) this.transactionTypeIsSet = false;
      else this.transactionTypeIsSet = true;
    }
    if (
      config.stripePaymentIntent &&
      this.stripePaymentIntentApplyFilter(optionsRequired.filter)
    ) {
      this.stripePaymentIntent = config.stripePaymentIntent;
      if (optionsRequired.unassign) this.stripePaymentIntentIsSet = false;
      else this.stripePaymentIntentIsSet = true;
    }
    if (
      config.stripePaymentSecret &&
      this.stripePaymentSecretApplyFilter(optionsRequired.filter)
    ) {
      this.stripePaymentSecret = config.stripePaymentSecret;
      if (optionsRequired.unassign) this.stripePaymentSecretIsSet = false;
      else this.stripePaymentSecretIsSet = true;
    }
    if (
      config.transactionAmountCents &&
      this.transactionAmountCentsApplyFilter(optionsRequired.filter)
    ) {
      this.transactionAmountCents = config.transactionAmountCents;
      if (optionsRequired.unassign) this.transactionAmountCentsIsSet = false;
      else this.transactionAmountCentsIsSet = true;
    }
    if (
      config.offSession &&
      this.offSessionApplyFilter(optionsRequired.filter)
    ) {
      this.offSession = config.offSession;
      if (optionsRequired.unassign) this.offSessionIsSet = false;
      else this.offSessionIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): StripeTransactionBaseTrackedI {
    const cloned = {} as StripeTransactionBaseTrackedI;
    if (
      this.transactionTypeIsSetDeep() &&
      this.transactionTypeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.transactionTypeIsSet = true;
      cloned.transactionType = this.transactionType;
    } else {
      //cloned.transactionTypeIsSet = false
    }
    if (
      this.stripePaymentIntentIsSetDeep() &&
      this.stripePaymentIntentApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.stripePaymentIntentIsSet = true;
      cloned.stripePaymentIntent = this.stripePaymentIntent;
    } else {
      //cloned.stripePaymentIntentIsSet = false
    }
    if (
      this.stripePaymentSecretIsSetDeep() &&
      this.stripePaymentSecretApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.stripePaymentSecretIsSet = true;
      cloned.stripePaymentSecret = this.stripePaymentSecret;
    } else {
      //cloned.stripePaymentSecretIsSet = false
    }
    if (
      this.transactionAmountCentsIsSetDeep() &&
      this.transactionAmountCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.transactionAmountCentsIsSet = true;
      cloned.transactionAmountCents = this.transactionAmountCents;
    } else {
      //cloned.transactionAmountCentsIsSet = false
    }
    if (
      this.offSessionIsSetDeep() &&
      this.offSessionApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.offSessionIsSet = true;
      cloned.offSession = this.offSession;
    } else {
      //cloned.offSessionIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): StripeTransactionBaseTrackedI {
    if (!this.transactionTypeApplyFilter(filter))
      this.transactionTypeIsSet = false;

    if (!this.stripePaymentIntentApplyFilter(filter))
      this.stripePaymentIntentIsSet = false;

    if (!this.stripePaymentSecretApplyFilter(filter))
      this.stripePaymentSecretIsSet = false;

    if (!this.transactionAmountCentsApplyFilter(filter))
      this.transactionAmountCentsIsSet = false;

    if (!this.offSessionApplyFilter(filter)) this.offSessionIsSet = false;

    return this;
  }
  transactionTypeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      StripeTransactionBaseMeta.transactionType,
      StripeTransactionBaseMeta,
      this.transactionType,
      this,
    );
  }
  transactionTypeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.transactionTypeIsSet && this.transactionTypeApplyFilter(filter))
      return true;

    return false;
  }
  stripePaymentIntentApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      StripeTransactionBaseMeta.stripePaymentIntent,
      StripeTransactionBaseMeta,
      this.stripePaymentIntent,
      this,
    );
  }
  stripePaymentIntentIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.stripePaymentIntentIsSet &&
      this.stripePaymentIntentApplyFilter(filter)
    )
      return true;

    return false;
  }
  stripePaymentSecretApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      StripeTransactionBaseMeta.stripePaymentSecret,
      StripeTransactionBaseMeta,
      this.stripePaymentSecret,
      this,
    );
  }
  stripePaymentSecretIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.stripePaymentSecretIsSet &&
      this.stripePaymentSecretApplyFilter(filter)
    )
      return true;

    return false;
  }
  transactionAmountCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      StripeTransactionBaseMeta.transactionAmountCents,
      StripeTransactionBaseMeta,
      this.transactionAmountCents,
      this,
    );
  }
  transactionAmountCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.transactionAmountCentsIsSet &&
      this.transactionAmountCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  offSessionApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      StripeTransactionBaseMeta.offSession,
      StripeTransactionBaseMeta,
      this.offSession,
      this,
    );
  }
  offSessionIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.offSessionIsSet && this.offSessionApplyFilter(filter)) return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.transactionTypeIsSetDeep(filter)) return true;
    if (this.stripePaymentIntentIsSetDeep(filter)) return true;
    if (this.stripePaymentSecretIsSetDeep(filter)) return true;
    if (this.transactionAmountCentsIsSetDeep(filter)) return true;
    if (this.offSessionIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
